import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dae70978"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "error_message"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error_message_item_icon" }, null, -1))
const _hoisted_3 = { class: "error_message_item_text" }

import { PropType } from 'vue';

// 複数のErrorMessageコンポーネントが呼び出されたときに一意のkeyを生成するためのindex
let errorIndex = 0;

export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorMessage',
  props: {
  errors: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
},
  setup(__props) {

const props = __props

errorIndex++;



return (_ctx: any,_cache: any) => {
  return (props.errors.length > 0)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "error_message_item",
            key: `err-${_unref(errorIndex)}_${error}`
          }, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, _toDisplayString(error), 1)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})